import { FileExtensionData } from './schema/FileExtensionData';
import { FileExtensionType } from './schema/FileExtensionType';

// Exported utils
export { getFileExtensionData } from './utils/getFileExtensionData';

// Exported types
export { FileExtensionType, FileExtensionData };
